import { render, staticRenderFns } from "./DifficultyInput.vue?vue&type=template&id=0d24cd7d&scoped=true"
import script from "./DifficultyInput.vue?vue&type=script&lang=js"
export * from "./DifficultyInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d24cd7d",
  null
  
)

export default component.exports